export interface CheckpointExecute {
  plantId: number;
  type: CheckpointExecuteTypeEnum | null;
  checkpointResultId: number | null;
}

export enum CheckpointExecuteTypeEnum {
  ALL = "ALL",
}
